export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5050"
    : "https://cloterenotaire.onrender.com");
